import { Transition } from "../Transition/index.js";
import morphdom from "morphdom";
class FrameTarget extends Transition {
  /**
   * Config.
   */
  static config = {
    name: "FrameTarget",
    options: {
      mode: {
        type: String,
        default: "replace"
        // or 'prepend' or 'append'
      }
    }
  };
  /**
   * Different mode of content insertion.
   */
  modes = {
    APPEND: "append",
    PREPEND: "prepend",
    REPLACE: "replace"
  };
  /**
   * Get uniq ID.
   */
  get id() {
    return this.$el.id;
  }
  /**
   * Update the content from the new target.
   */
  async updateContent(content = null) {
    if (!content) {
      return;
    }
    const { mode } = this.$options;
    if (mode === this.modes.APPEND || mode === this.modes.PREPEND) {
      const leaveTargets = Array.from(this.$el.children);
      const enterTargets = Array.from(content.children);
      this.$el[mode](...Array.from(content.childNodes));
      await Promise.all([
        this.leave(leaveTargets),
        this.enter(enterTargets)
      ]);
    } else {
      await this.leave();
      morphdom(this.$el, content);
      await this.enter();
    }
  }
}
export {
  FrameTarget
};
//# sourceMappingURL=FrameTarget.js.map
